


















import { Component, Prop, Vue } from 'vue-property-decorator';
import ClassItemRate from '../../../models/interfaces/ClassItemRate';
import ClassItem from '../../../models/interfaces/ClassItem';
import likeDislike from './likeDislike.vue';
import { ClassItemType } from '@/models/enums/ClassItemType';

@Component({ components: { likeDislike } })
export default class ClassOptionalLikeDislike extends Vue {
  @Prop({ required: true })
  public readonly item!: ClassItem;

  @Prop({ required: true, type: Object, default: () => ({}) })
  public readonly value!: ClassItemRate;

  public like: boolean = null;
  public doNotAnswer: boolean = false;

  public get enableDoNotAnswer(): boolean {
    return this.item.type === ClassItemType.optionalLikeDislike;
  }

  public setDoNotAnswer(doNotAnswerValue: boolean): void {
    this.doNotAnswer = doNotAnswerValue;
    if (doNotAnswerValue) {
      this.value.like = null;
    }
    this.updateLike();
  }

  public updateLike(): void {
    if (this.value.like === true) this.value.score = 1;
    if (this.value.like === false) this.value.score = -1;
    if (this.value.like === null) this.value.score = 0;
    this.$emit('input', this.value);
  }
}
